import { useMemo } from "react";
import { useCharacters } from "./useCharacters";
import { useCurrentPlayer } from "./useCurrentPlayer";

export function usePlayerCharacter() {
  const id = useCurrentPlayer();
  const [character] = useCharacters(useMemo(() => (id ? [id] : []), [id]));
  return useMemo(() => character, [character]);
}
